import React, { Component } from 'react'

import { inject, observer } from 'mobx-react'

import { notifyOverlayOpen } from '~/client/src/shared/utils/overlayNotifier'

import Localization from '../../localization/LocalizationManager'
import LocationBase from '../../models/LocationObjects/LocationBase'
import LocationAttributesStore from '../../stores/domain/LocationAttributes.store'
import InitialState from '../../stores/InitialState'
import type { ListSelectorTitleVariant } from '../ListSelector/ListSelector'
import { WorkflowTypeListSelector } from '../WorkflowTypeListSelector'

interface IProps {
  onSelect: (formTypeId: string) => void
  onClose: () => void
  hideHeader?: boolean
  titleVariant?: ListSelectorTitleVariant
  allowedTypeIds?: string[]
  selectedTypeId?: string
  locationAttributesStore?: LocationAttributesStore
  state?: InitialState
}

@inject('locationAttributesStore', 'state')
@observer
export default class FormTypeSelectionForm extends Component<IProps> {
  private closeOverlay: (() => void) | null = null

  public componentDidMount() {
    this.closeOverlay = notifyOverlayOpen()
  }

  public componentWillUnmount() {
    this.closeOverlay?.()
    this.closeOverlay = null
  }

  public render() {
    const { onSelect, onClose, hideHeader, titleVariant } = this.props

    return (
      <div className="tw:flex tw:h-full tw:flex-col">
        <div className="tw:min-h-0 tw:flex-1">
          <WorkflowTypeListSelector
            mode="single"
            title={
              hideHeader
                ? undefined
                : Localization.translator.selectWorkflowType
            }
            onClose={hideHeader ? undefined : onClose}
            titleVariant={titleVariant}
            onSelect={onSelect}
            filterByLocation={this.filterByLocation}
            allowedTypeIds={this.props.allowedTypeIds}
            selectedId={this.props.selectedTypeId}
          />
        </div>
      </div>
    )
  }

  private get filterByLocation(): LocationBase {
    return this.props.state.preSelectedSiteLocation?.id
      ? this.props.locationAttributesStore.allLocationsWithoutEquipmentMap[
          this.props.state.preSelectedSiteLocation.id
        ]
      : null
  }
}
